import { call, put } from "redux-saga/effects";

import { api, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateCompanyDocksActions } from "store/ducks/settings/company-docks";

export function* paginateCompanyDocksRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      api.get,
      `/company-docks?${queryString}`
    );

    const { companyDocks, pagination } = responseBody;
    yield put(PaginateCompanyDocksActions.success(companyDocks, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateCompanyDocksActions.failure(errorMessage));
  }
}
